$('.banner-wrap').slick({
    prevArrow: $('.navigation-panel-banner .nav-prev'),
    nextArrow: $('.navigation-panel-banner .nav-next'),
    dots: true,
    fade: true,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 6000,
    speed: 3500
});

$('.realization-wrap-img').slick({
    arrows: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 555,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.realization--wrap').magnificPopup({
    gallery:{enabled:true},
    delegate: '.item-realization.show',
    type:'image'
});

$('.realization-wrap-img').magnificPopup({
    gallery:{enabled:true},
    delegate: 'div.realization-item:not(.slick-cloned) > a',
    type:'image'
});


$('.partners-wrap').slick({
    arrows: false,
    slidesToShow: 7,
    slidesToScroll: 7,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    infinite: true,
    responsive: [
        {
            breakpoint: 1000,
            settings: {
                dots: false,
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 555,
            settings: {
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.video--slider-wrap').slick({
    prevArrow: $('.arrow--slider-prev'),
    nextArrow: $('.arrow--slider-next'),
    slidesToShow: 3,
    slidesToScroll: 3,
    vertical: true,
    dots: false,
    infinite: true
});

$(window).scroll(function(){
    if($(window).scrollTop() > 0 ) {
        $("header").addClass('header-scroll');
    } else {
        $("header").removeClass('header-scroll');
    }
});

$(".arrow-top").click(function() {
    $('html, body').animate({
        scrollTop: 0
    }, 1500);
});


var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
$('.video--slider-item').bind('click', function(e) {
    e.preventDefault();
    $('.v-left-area').html('<div id="video--inner" class="video--inner"></div>');
    var player;
    var videoData = $(this).data('videoid');
    player = new YT.Player('video--inner', {
        height: '100%',
        width: '100%',
        videoId: videoData,
        playerVars: {
            showinfo: 0,
            rel: 0
        },
        events: {
            'onReady': function(e) { /* e.target.playVideo(); */ }
        }
    });
});

function onYouTubeIframeAPIReady() {
    if ($('.video--slider-wrap').length > 0) {
        if ($('.video--slider-item').length > 0) {
            $('.video--slider-item').click();
        } else {
            $('.galleryVideo .videoSlider > a:not(.bx-clone)')[0].click();
        }
    }
}

(function() {
    // trim polyfill : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
    if (!String.prototype.trim) {
        (function() {
            // Make sure we trim BOM and NBSP
            var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
            String.prototype.trim = function() {
                return this.replace(rtrim, '');
            };
        })();
    }

    [].slice.call( document.querySelectorAll( '.input__field' ) ).forEach( function( inputEl ) {
        // in case the input is already filled..
        if( inputEl.value.trim() !== '' ) {
            classie.add( inputEl.parentNode, 'input--filled' );
        }

        // events:
        inputEl.addEventListener( 'focus', onInputFocus );
        inputEl.addEventListener( 'blur', onInputBlur );
    } );

    function onInputFocus( ev ) {
        classie.add( ev.target.parentNode, 'input--filled' );
    }

    function onInputBlur( ev ) {
        if( ev.target.value.trim() === '' ) {
            classie.remove( ev.target.parentNode, 'input--filled' );
        }
    }
})();

var wrapper = $( ".file_upload" ),
    inp = wrapper.find( "input" ),
    btn = wrapper.find( "button" ),
    lbl = wrapper.find( "mark" );
btn.focus(function(){
    inp.focus()
});
// Crutches for the :focus style:
inp.focus(function(){
    wrapper.addClass( "focus" );
}).blur(function(){
    wrapper.removeClass( "focus" );
});

btn.add( lbl ).click(function(){
    inp.click();
});

btn.focus(function(){
    wrapper.addClass( "focus" );
}).blur(function(){
    wrapper.removeClass( "focus" );
});

var file_api = ( window.File && window.FileReader && window.FileList && window.Blob ) ? true : false;
inp.change(function(){
    var file_name;
    if( file_api && inp[ 0 ].files[ 0 ] )
        file_name = inp[ 0 ].files[ 0 ].name;
    else
        file_name = inp.val().replace( "C:\\fakepath\\", '' );

    if( ! file_name.length )
        return;

    if( lbl.is( ":visible" ) ){
        lbl.text( file_name );
        btn.text( "WyĹlij CV" );
    }else
        btn.text( file_name );
}).change();

$('.header--menu').clone().appendTo('.mobileMenu');

$(".menu--mobile").click(function () {
    $(".mobileMenu").css("transform", "translateY(0)");
});

$(".mobileMenu").on('click', '.close_menu', function () {
    $(".mobileMenu").css("transform", "translateY(-100%)");
});